/* ==========================================================================
   Millennio — Cajón de variantes (#177)
   --------------------------------------------------------------------------
   Abre un cajón desde abajo con las presentaciones de un producto y añade al
   carrito la que se pulse.

   QUIÉN LO ABRE
   Cualquier tarjeta marcada con `data-mi-variantes-drawer` — hoy sólo las de
   la página de colección. En la home y en la ficha las tallas siguen en la
   tarjeta y este guion no interviene.

   DE DÓNDE SALEN LOS DATOS
   De las propias pastillas de la tarjeta (`[data-mi-talla]`), que en colección
   están ocultas por CSS pero siguen en el DOM. No se duplica nada en Liquid: si
   la tarjeta cambia su modelo de variantes, el cajón lo hereda.

   CÓMO AÑADE
   No reimplementa el carrito: elige la variante en la tarjeta —lo mismo que
   hace un clic en la pastilla— y dispara el `submit` de su `<form>`, que es el
   camino que ya funciona y que trae el cajón del carrito repintado.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__miVdr) { return; }
  window.__miVdr = true;

  var cajon, panel, lista, titulo;
  var tarjetaActiva = null;
  var focoPrevio = null;
  /* Que hacer con la variante elegida. Lo pone quien abre: la tarjeta pulsa su
     pastilla, la busqueda anade directo. */
  var elegido = null;

  function nodos() {
    if (cajon) { return true; }
    cajon = document.getElementById('mi-vdr');
    if (!cajon) { return false; }
    /* SE MUDA AL <body>, Y NO ES CAPRICHO.
       MEDIDO al abrirlo desde el cajon de busqueda (#98): el panel de
       variantes se pintaba DEBAJO del buscador y solo asomaba por la franja
       de la izquierda, pese a tener `z-index: 1000` contra el 940 del
       buscador. La razon es que el `z-index` solo compara DENTRO del mismo
       contexto de apilamiento, y este cajon nace envuelto en el contenedor de
       scroll suave del tema, que crea el suyo con un `transform`: todo su
       contenido queda por debajo de lo que cuelgue directo del <body>, sea cual
       sea el numero.
       Colgar del <body> es lo mismo que ya hace mi-search.js con el buscador. */
    if (cajon.parentNode !== document.body) { document.body.appendChild(cajon); }

    panel = cajon.querySelector('.mi-vdr__panel');
    lista = cajon.querySelector('[data-mi-vdr-lista]');
    titulo = cajon.querySelector('.mi-vdr__titulo');
    return true;
  }

  /* ---- Abrir / cerrar ---------------------------------------------------- */

  /* LA PUERTA DE DATOS.
     #98 — el cajon de busqueda tambien necesita elegir variante, y alli no hay
     tarjeta de la que leer pastillas: sus filas vienen del endpoint de
     sugerencias. En vez de un segundo cajon con otra animacion y otras
     teclas, este acepta una lista.

     `opciones`: [{ vid, nombre, precio, disponible }]
     `alElegir(vid)`: que hacer con la elegida. El cajon no decide como se
     anade al carrito; solo recoge la eleccion. */
  function abrirDatos(tituloTxt, opciones, alElegir) {
    if (!nodos() || !opciones || opciones.length < 2) { return false; }

    focoPrevio = document.activeElement;
    elegido = typeof alElegir === 'function' ? alElegir : null;
    titulo.textContent = tituloTxt || '';

    lista.innerHTML = '';
    opciones.forEach(function (o) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mi-vdr__op';
      b.dataset.miVdrVid = o.vid || '';
      b.disabled = !o.disponible;

      var nom = document.createElement('span');
      nom.textContent = o.nombre || '';

      var der = document.createElement('span');
      der.className = o.disponible ? 'mi-vdr__op-precio' : 'mi-vdr__op-agotado';
      der.textContent = o.disponible ? (o.precio || '') : 'Agotado';

      b.appendChild(nom);
      b.appendChild(der);
      li.appendChild(b);
      lista.appendChild(li);
    });

    cajon.hidden = false;
    /* Dos fotogramas antes de marcar `esta-abierto`: con uno solo el navegador
       puede colapsar el cambio de `hidden` y el de la clase en el mismo estilo
       computado, y la transicion no llega a correr — el cajon apareceria de
       golpe en vez de subir. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { cajon.classList.add('esta-abierto'); });
    });
    document.documentElement.style.overflow = 'hidden';

    var primero = lista.querySelector('.mi-vdr__op:not(:disabled)');
    if (primero) { primero.focus(); }
    return true;
  }

  /* La puerta de TARJETA: lee las pastillas y delega en la de datos. */
  function abrir(tarjeta) {
    if (!nodos()) { return false; }
    var pastillas = [].slice.call(tarjeta.querySelectorAll('[data-mi-talla]'));
    if (pastillas.length < 2) { return false; }   // una sola variante: no hay nada que elegir

    tarjetaActiva = tarjeta;
    var nombre = tarjeta.querySelector('[data-mi-ir]');

    return abrirDatos(
      (nombre && nombre.getAttribute('aria-label')) || '',
      pastillas.map(function (p) {
        return {
          vid: p.dataset.miVid || '',
          nombre: (p.textContent || '').trim(),
          precio: p.dataset.miPrecio || '',
          disponible: p.dataset.miDisp === '1'
        };
      }),
      elegirYAnadirEnTarjeta
    );
  }

  window.miVdr = window.miVdr || {};
  window.miVdr.abrirDatos = abrirDatos;
  window.miVdr.cerrar = function () { cerrar(); };

  function cerrar() {
    if (!cajon || cajon.hidden) { return; }
    cajon.classList.remove('esta-abierto');
    document.documentElement.style.overflow = '';
    var fin = function () { cajon.hidden = true; };
    /* Se espera a que baje; el salvavidas cubre el caso de que la transición
       no dispare (pestaña oculta, movimiento reducido). */
    var hecho = false;
    panel.addEventListener('transitionend', function t(e) {
      if (e.target !== panel || hecho) { return; }
      hecho = true; panel.removeEventListener('transitionend', t); fin();
    });
    setTimeout(function () { if (!hecho) { hecho = true; fin(); } }, 420);
    if (focoPrevio && focoPrevio.focus) { focoPrevio.focus(); }
    tarjetaActiva = null;
    elegido = null;
  }

  /* ---- Elegir y añadir --------------------------------------------------- */
  function elegirYAnadirEnTarjeta(vid) {
    if (!tarjetaActiva || !vid) { return; }
    var t = tarjetaActiva;
    /* Se pulsa la pastilla real en vez de escribir el input a mano: así toda la
       sincronía que ya hace la tarjeta —precio, tachado, ahorro, enlace a la
       ficha, estado del CTA— ocurre igual que si el comprador la hubiera
       tocado. Escribir sólo el input dejaría la tarjeta diciendo otra cosa. */
    var pastilla = t.querySelector('[data-mi-talla][data-mi-vid="' + vid + '"]');
    if (pastilla) { pastilla.click(); }

    var cta = t.querySelector('[data-mi-cta]');
    cerrar();
    if (cta) {
      /* Tras cerrar, para que el cajón del carrito no se monte debajo de este.
         El retardo es el mismo de la transición. */
      setTimeout(function () { cta.dataset.miVdrListo = '1'; cta.click(); }, 340);
    }
  }

  /* ---- Enganches --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) { return; }

    if (e.target.closest('[data-mi-vdr-cerrar]')) { cerrar(); return; }

    var op = e.target.closest('.mi-vdr__op');
    if (op && !op.disabled) {
      /* Se guarda ANTES de cerrar: `cerrar()` limpia el estado. */
      var hacer = elegido, vid = op.dataset.miVdrVid;
      if (hacer) { hacer(vid); } else { cerrar(); }
      return;
    }

    var cta = e.target.closest('[data-mi-cta]');
    if (!cta) { return; }
    var tarjeta = cta.closest('[data-mi-tarjeta]');
    if (!tarjeta || !tarjeta.hasAttribute('data-mi-variantes-drawer')) { return; }
    /* Bandera de un solo uso: la segunda pulsacion —la que dispara el guion—
       tiene que pasar de largo o el cajon se reabriria en bucle.
       AQUI NO SE BORRA: la gasta mi-product-card.js, que es quien anade. Si la
       borraran los dos, el resultado dependeria de cual capturase primero, que
       es justo la carrera que este reparto elimina. */
    if (cta.dataset.miVdrListo === '1') { return; }
    if (abrir(tarjeta)) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!cajon || cajon.hidden) { return; }
    if (e.key === 'Escape') { cerrar(); return; }
    if (e.key !== 'Tab') { return; }
    /* Foco atrapado: un cajón modal del que se sale con el tabulador deja al
       teclado navegando una página que no puede ver. */
    var f = [].slice.call(panel.querySelectorAll('button:not(:disabled)'));
    if (!f.length) { return; }
    var pri = f[0], ult = f[f.length - 1];
    if (e.shiftKey && document.activeElement === pri) { e.preventDefault(); ult.focus(); }
    else if (!e.shiftKey && document.activeElement === ult) { e.preventDefault(); pri.focus(); }
  });
})();
